export const MODEL_NAME = "bert-base-multilingual-cased-ner-hrl"
